/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_BlockInputs */



/**
* | output |
* | --- |
* | "( █ ) Full Block" |
*
* @param {Full_BlockInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const full_block = /** @type {((inputs?: Full_BlockInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_BlockInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("( █ ) Bloc plein")
	if (locale === "de") return /** @type {LocalizedString} */ ("( █ ) Vollständiger Block")
	if (locale === "it") return /** @type {LocalizedString} */ ("( █ ) Blocco completo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("( █ ) Полный блок")
	if (locale === "es") return /** @type {LocalizedString} */ ("( █ ) Bloque completo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("（█）完整块")
	if (locale === "ja") return /** @type {LocalizedString} */ ("（█）フルブロック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("( █ ) पूर्ण ब्लॉक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("( █ ) Bloco Completo")
	return /** @type {LocalizedString} */ ("( █ ) Full Block")
});